import { Redirect, Route, withRouter } from "react-router-dom";
import AuthRender from "../containers/AuthRender";
import React, { useEffect } from "react";

const PrivateRoute = ({ component: Component, minRole, service, oneServiceOf, location, ...rest }) => {
  useEffect(() => {}, []);

  return (
    <Route
      {...rest}
      render={props => {
        const redirect = (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        );

        return (
          <AuthRender minRole={minRole} service={service} oneServiceOf={oneServiceOf} unauthorizedRender={redirect}>
            <Component {...props} />
          </AuthRender>
        );
      }}
    />
  );
};

export default PrivateRoute;



// WEBPACK FOOTER //
// src/routes/PrivateRoute.js